import {useState} from '../../app3';
import api from '../../api';

function stringSplice(string, idx, rem, str) {
  return string.slice(0, idx) + str + string.slice(idx + Math.abs(rem));
}

function formatTextNodes(h, textObj) {

  const rows = textObj.text.split('\n');

  return rows.map(row => {
    if (row === '') {
      return h('br')
    }

    let str = row.substring(0, 28);

    if (str.length > 27) {
      str += '...';
    }

    return String(str);
  });
}

export default function ChatList({airgram, store, props}) {
  const [state, patch] = useState({
    chats: [],
    test: 'https://randomuser.me/api/portraits/men/61.jpg',
  });

  airgram.api.getChats({
    offsetOrder: '9223372036854775807',
    limit: 40,
  }).then(async ({response}) => {
    let chats = response.chatIds.map(id => {
      return api.chats.getChat({
        chatId: id,
      })
        .then(async (chat) => {
          if (!chat.photo) {
            return chat;
          }

          const file = await api.files.downloadFile({
            fileId: chat.photo.small.id,
          });

          chat.photoUrl = file.dataUrl;

          return chat;
        })
    });

    chats = await Promise.all(chats);

    patch({
      chats: [...state.chats, ...chats],
    });
  })

  function handleClickChat(e, chat) {
    console.log('CHANGE CHAT ID');
    store.stores.chats.activeChatId = chat.id;


    // Pass state
    // airgram.api.getRemoteFile({ remoteFileId: chat.photo.small.remote.id }).then((a) => {
    //   console.log(a);
    // const { willBeDownloaded } = a.state.getState()
    // console.info(`willBeDownloaded: ${willBeDownloaded}`) // output: true
    // })

    // props.handleClickChat(e, chat.id);
  }

  return h => {
    return h('ul', 'chat-list', state.chats.map(chat => {
        const messageDate = new Date();
        messageDate.setTime(chat.lastMessage.date * 1000);


        return h('li', {
          attrs: {
            class: 'chat-list__item',
          },
          on: {
            click: (e) => handleClickChat(e, chat),
          },
        }, [
          h('div', 'chat-preview', [
            h('div', 'chat-preview__avatar is-online', [
              chat.photoUrl
                ? h('img', {
                  attrs: {
                    src: chat.photoUrl,
                  },
                })
                : h('div', 'not-avatar', chat.title[0]),
            ]),
            h('div', 'chat-preview__body', [
              h('div', 'chat-preview__title', [
                chat.title,
                h('div', 'chat-preview__meta', `${messageDate.getHours()}:${messageDate.getMinutes()}`),
              ]),
              h('div', 'chat-preview__text', [
                h('p', 'chat-preview__message', [
                  formatTextNodes(h, chat.lastMessage.content.text || {text: '', entities: []})[0],
                ]),
                chat.unreadCount > 0
                  ? h('span', 'chat-preview__badge badge badge--success', String(chat.unreadCount))
                  : null,
              ]),
            ]),
          ]),
        ])
      }),
    )
  }
}
